import React from 'react';

/* LA RANGÉE DES OFFRES, tout en haut (demande d'Olivier, 2026-10-21) : « Vue globale », la carte du chiffre
   d'affaires de toutes les offres, puis un bouton par offre qui ouvre sa grille seule. Le modèle de l'offre se
   lit sous son nom. Un clic droit ouvre le menu de l'offre (Modifier l'offre…). */
const EQUATIONS = (p) => ({
  volume_price: p('Volume × prix'), time_rate: p('Temps × tarif'), project: p('Montant'),
  capacity_occupancy: p('Capacité × occupation'), base_arpu: p('Base × revenu unitaire'), base_rate: p('Assiette × taux'),
});
export const libelleEquation = (p, e) => EQUATIONS(p)[e] || e;

export default function OfferTabs({ c }) {
  const { p, vue, choix, choisir, ouvrirMenu } = c;
  return (
    <div className="pv-vues" role="tablist" aria-label={p('Offres')}>
      <button type="button" role="tab" aria-selected={choix === 'all'} className={`pv-vue${choix === 'all' ? ' is-on' : ''}`}
              onClick={() => choisir('all')}>
        <b>{p('Vue globale')}</b><small>{p('Toutes les offres')}</small>
      </button>
      <span className="pv-vues__sep" aria-hidden="true" />
      {vue.rows.map((r) => (
        <button key={r.offer_id} type="button" role="tab" aria-selected={choix === r.offer_id}
                className={`pv-vue${choix === r.offer_id ? ' is-on' : ''}`}
                onClick={() => choisir(r.offer_id)}
                onContextMenu={(e) => ouvrirMenu(e, r)}>
          <b>{r.name}</b><small>{libelleEquation(p, r.equation)}</small>
        </button>
      ))}
    </div>
  );
}
